<template>
  <div class="card" v-for="(status, index) in skeleton" :key="index">
    <div class="head">
      <div class="head-right">
        <Skeletor width="100px" />
      </div>
      <div class="head-left">
        <Skeletor width="100px" />
      </div>
    </div>
    <div class="body">
      <div class="transaction-about">
        <Skeletor width="200px" />
      </div>
      <div class="transaction-amount">
        <Skeletor width="100px" />
      </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";

export default {
  name: "transaction-item-skeleton.vue",
  data() {
    return {
      skeleton: 4
    }
  },
  components: {
    Skeletor
  }
}
</script>

<style scoped>

</style>
